import { defineMessages } from "react-intl"
import { ColumnDefinition, ColumnDefinitionCategory, DataType, TotalType } from "."
import { ObjectType, ObjectTypeConfig } from ".."
import SchedulingPageStatusBadge from "../../../../scheduling-page/status.component.jsx"
import { PREFERENCE_TYPE } from "../../constants"
export enum SchedulingPagesColumnIds {
    IDENTIFIER = "identifier",
    LOCATION = "locationName",
    TITLE = "title",
    ACTIVATED_AT_DATE = "activatedAt",
    STATUS = "status",
    CREATED_AT_DATE = "createdAt"
}
const columnDefinitions: ColumnDefinition[] = [
    {
        id: SchedulingPagesColumnIds.IDENTIFIER,
        sortId: "identifierInteger",
        defaultSort: true,
        dataType: DataType.LINK,
        dataAttributes: {
            redirect: "/scheduling-pages/{id}/edit"
        },
        totalAttributes: {
            key: "totalItemsCount",
            type: TotalType.STRING,
        },
        sortable: true,
        identifier: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT],
    },
    {
        id: SchedulingPagesColumnIds.LOCATION,
        sortId: "locationNameSort",
        dataType: DataType.LOCATION,
        dataAttributes: {
            redirect: "/locations/{locationId}/edit"
        },
        sortable: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT],
    },
    {
        id: SchedulingPagesColumnIds.TITLE,
        sortId: "titleKeyword",
        dataType: DataType.STRING,
        sortable: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT],
    },
    {
        id: SchedulingPagesColumnIds.ACTIVATED_AT_DATE,
        dataType: DataType.DATE,
        sortId: "activatedAt",
        sortable: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT, ColumnDefinitionCategory.DATE_RELATED],
    },
    {
        id: SchedulingPagesColumnIds.STATUS,
        dataType: DataType.COMPONENT,
        sortId:"status",
        dataAttributes: {
            component: SchedulingPageStatusBadge,
            props: {
                status : SchedulingPagesColumnIds.STATUS
            }
        },
        sortable: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT],
    },
    {
        id: SchedulingPagesColumnIds.CREATED_AT_DATE,
        dataType: DataType.DATE,
        sortId: "createdAt",
        sortable: true,
        defaultView: false,
        categories: [ColumnDefinitionCategory.DATE_RELATED],
    },
]
const headerMessages = defineMessages({
    [SchedulingPagesColumnIds.IDENTIFIER]: {
        id: "generic-listing.scheduling-pages.table-header.identifier",
        defaultMessage: "ID",
    },
    [SchedulingPagesColumnIds.LOCATION]: {
        id: "generic-listing.scheduling-pages.table-header.location",
        defaultMessage: "Location",
    },
    [SchedulingPagesColumnIds.TITLE]: {
        id: "generic-listing.scheduling-pages.table-header.title",
        defaultMessage: "Title",
    },
    [SchedulingPagesColumnIds.ACTIVATED_AT_DATE]: {
        id: "generic-listing.scheduling-pages.table-header.activated_at",
        defaultMessage: "Activated at",
    },
    [SchedulingPagesColumnIds.STATUS]: {
        id: "generic-listing.scheduling-pages.table-header.status",
        defaultMessage: "Status",
    },
    [SchedulingPagesColumnIds.CREATED_AT_DATE]: {
        id: "generic-listing.scheduling-pages.table-header.created_at",
        defaultMessage: "Created at",
    },
})
const configuration: ObjectTypeConfig = {
    objectType: ObjectType.SCHEDULING_PAGES,
    columnDefinitions,
    headerMessages,
    listingPreferencesKey: PREFERENCE_TYPE.LISTING_SCHEDULING_PAGES,
    searchPlaceholder: {
        id: "generic-listing.scheduling-pages.search-placeholder",
        defaultMessage: "Search a scheduling page...",
    },
    displayString: {
        id: "generic-listing.scheduling-pages.display-string",
        defaultMessage: "Scheduling pages",
    },
    searchObjectType: ObjectType.SCHEDULING_PAGES,
    bulkActionDefinitions: [],
    creationButtonComponent: require("../../../../common/listing/generic-listing/creation-buttons/SchedulingPageCreationButton"),
}
export default configuration


// WEBPACK FOOTER //
// ./src/state/listing/generic-listing/column-definitions/scheduling-pages.ts